import VehiclesError from './VehiclesError.js'

export class GetSubscriptionModelsVehiclesError extends VehiclesError {}
